module.exports = __webpack_public_path__ + "img/2025-07-21c_2.d6a6a2c3.jpg";